import React, { useState, useEffect, useRef } from 'react';
import { auth } from '../firebase';

const UserProfile = ({ user }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const containerRef = useRef(null);

  // Close the menu when clicking outside of the component
  useEffect(() => {
    if (!isMenuOpen) return;

    const handlePointerDown = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, [isMenuOpen]);

  const handleSignOut = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="user-profile-container">
      <div className="user-profile-wrapper" ref={containerRef}>
        <div 
          onClick={() => setIsMenuOpen(!isMenuOpen)} 
          className="user-profile-name"
        >
          {user.displayName}
        </div>
        
        {isMenuOpen && (
          <div className="user-profile-menu">
            <div
              onClick={handleSignOut}
              className="user-profile-menu-item"
            >
              Sign Out
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfile;